import React from "react";

import "./Button.css";

/**
 * The app's only button. The variants cover every case the ad-hoc button
 * classes used to: primary actions, cancel/secondary, and destructive.
 */
export default function Button({
  children,
  variant = "primary",
  type = "button",
  disabled = false,
  ...props
}) {
  return (
    <button
      className={`btn btn--${variant}`}
      type={type}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
